export default __webpack_public_path__ + "static/18698-6aa0c4207c80d5624dcb3cceaf82ffc9.jpg";